(function () {
  const ROUTES_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  const CART_JS = ROUTES_ROOT + "cart.js";
  const CHANGE_JS = ROUTES_ROOT + "cart/change.js";
  const UPDATE_JS = ROUTES_ROOT + "cart/update.js";
  const CART_SYNC_RELOAD_KEY = "23dtf_personalized_cart_sync_reloaded";
  let cartMutationBusy = false;

  // ---------------------------
  // Helpers
  // ---------------------------
  function escapeHtml(str) {
    return String(str || "").replace(/[&<>"']/g, (s) => {
      return (
        {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#39;",
        }[s] || s
      );
    });
  }

  async function fetchCart() {
    const res = await fetch(CART_JS, { credentials: "same-origin" });
    if (!res.ok) throw new Error("No se pudo leer /cart.js");
    return res.json();
  }

  async function changeLine(key, quantity) {
    const res = await fetch(CHANGE_JS, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: key, quantity }),
    });

    if (!res.ok) {
      let msg = "Error al actualizar el carrito.";
      try {
        const data = await res.json();
        if (data && data.description) msg = data.description;
      } catch (e) {}
      throw new Error(msg);
    }
    return res.json();
  }

  async function updateLines(updates) {
    const cleanUpdates = {};
    Object.entries(updates || {}).forEach(([key, quantity]) => {
      if (!key) return;
      cleanUpdates[String(key)] = Math.max(0, parseInt(quantity || "0", 10) || 0);
    });

    if (!Object.keys(cleanUpdates).length) return fetchCart();

    const res = await fetch(UPDATE_JS, {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ updates: cleanUpdates }),
    });

    if (!res.ok) {
      let msg = "Error al sincronizar el carrito.";
      try {
        const data = await res.json();
        if (data && (data.description || data.message)) msg = data.description || data.message;
      } catch (e) {}
      throw new Error(msg);
    }

    return res.json();
  }

  function getGroupIdFromRow(btn) {
    const row = btn.closest(".cart-bundle");
    return row ? row.getAttribute("data-group-id") : null;
  }

  function getProperty(item, key) {
    const p = item && item.properties ? item.properties : {};
    return p && Object.prototype.hasOwnProperty.call(p, key) ? p[key] : null;
  }

  function isDTFLineBySignals(item) {
    const type = getProperty(item, "_item_type");
    return (
      type === "dtf" ||
      !!getProperty(item, "_dtf_service") ||
      !!getProperty(item, "DTF Servicio") ||
      !!getProperty(item, "DTF Plantilla") ||
      !!getProperty(item, "DTF Archivo") ||
      !!getProperty(item, "DTF_GRUPO") ||
      !!getProperty(item, "DTF Grupo")
    );
  }

  function handleize(value) {
    return String(value || "sin-color")
      .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      .toLowerCase().replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "") || "sin-color";
  }

  const SIZE_ORDER = ["XXS", "XS", "S", "M", "L", "XL", "XXL", "2XL", "3XL", "4XL", "5XL", "6XL"];

  function normalizedSize(value) {
    return String(value || "").trim().toUpperCase().replace(/\s+/g, "");
  }

  function sizeRank(value) {
    const normalized = normalizedSize(value);
    const aliases = {
      "XXXL": "3XL",
      "XXXXL": "4XL",
      "XXXXXL": "5XL",
      "XXXXXXL": "6XL",
    };
    const canonical = aliases[normalized] || normalized;
    const index = SIZE_ORDER.indexOf(canonical);
    return index === -1 ? 999 : index;
  }

  function itemOption(item, index) {
    if (item && Array.isArray(item.options) && item.options[index] != null) return String(item.options[index]);
    if (item && Array.isArray(item.variant_options) && item.variant_options[index] != null) return String(item.variant_options[index]);
    return "";
  }

  function compareGarmentLines(a, b) {
    const colorCompare = String(a.color || "").localeCompare(String(b.color || ""), "es", { sensitivity: "base" });
    if (colorCompare) return colorCompare;

    const rankCompare = sizeRank(a.size) - sizeRank(b.size);
    if (rankCompare) return rankCompare;

    return String(a.size || "").localeCompare(String(b.size || ""), "es", { numeric: true, sensitivity: "base" });
  }

  function isNormalGroupId(groupId) {
    return String(groupId || "").indexOf("normal__") === 0;
  }

  function normalGroupIdForItem(item) {
    const productId = item && (item.product_id || (item.product && item.product.id));
    // v1.0-pre13A.3: todos los colores y tallas del mismo producto normal
    // pertenecen a una única tarjeta virtual del carrito.
    return "normal__" + String(productId || "0");
  }

  function belongsToBundle(item, groupId) {
    if (!item || !groupId) return false;
    const gid = getProperty(item, "_group_id");

    // Productos normales sin personalización: el Liquid crea un grupo virtual
    // por producto, para que todos sus colores y tallas se vean
    // dentro de una única tarjeta.
    if (isNormalGroupId(groupId)) {
      return !gid && normalGroupIdForItem(item) === groupId;
    }

    return gid === groupId;
  }

  function isPersonalizedGarment(item) {
    return getProperty(item, "_item_type") === "personalized_garment";
  }

  function isPersonalizationService(item) {
    return getProperty(item, "_item_type") === "personalization";
  }

  function personalizedGroupIds(cart) {
    const ids = new Set();
    (cart && Array.isArray(cart.items) ? cart.items : []).forEach((item) => {
      const gid = getProperty(item, "_group_id");
      if (!gid || (!isPersonalizedGarment(item) && !isPersonalizationService(item))) return;
      ids.add(String(gid));
    });
    return Array.from(ids);
  }

  function personalizedParentKey(item) {
    return item && item.parent_relationship && item.parent_relationship.parent_key
      ? String(item.parent_relationship.parent_key)
      : "";
  }

  function personalizedParentRef(item) {
    return String(getProperty(item, "_23dtf_parent_ref") || "");
  }

  function personalizedGroupSnapshot(cart, groupId) {
    const lines = (cart && Array.isArray(cart.items) ? cart.items : []).filter((item) => {
      return belongsToBundle(item, groupId) && !isDTFLineBySignals(item);
    });
    const garments = lines.filter(isPersonalizedGarment);
    const services = lines.filter(isPersonalizationService);
    const garmentTotal = garments.reduce((sum, item) => sum + Math.max(0, Number(item.quantity || 0)), 0);
    const garmentsByKey = new Map();
    const garmentsByRef = new Map();

    garments.forEach((garment) => {
      if (garment && garment.key) garmentsByKey.set(String(garment.key), garment);
      const ref = personalizedParentRef(garment);
      if (ref) garmentsByRef.set(ref, garment);
    });

    return { lines, garments, services, garmentTotal, garmentsByKey, garmentsByRef };
  }

  function personalizationServiceTargetQuantity(service, snapshot) {
    if (!service || !snapshot) return 0;

    const parentKey = personalizedParentKey(service);
    if (parentKey && snapshot.garmentsByKey.has(parentKey)) {
      return Math.max(0, Number(snapshot.garmentsByKey.get(parentKey).quantity || 0));
    }

    const parentRef = personalizedParentRef(service);
    if (parentRef && snapshot.garmentsByRef.has(parentRef)) {
      return Math.max(0, Number(snapshot.garmentsByRef.get(parentRef).quantity || 0));
    }

    return Math.max(0, Number(snapshot.garmentTotal || 0));
  }

  async function syncPersonalizationServices(groupId, cart) {
    if (!groupId || isNormalGroupId(groupId)) return { changed: false, cart: cart || null };
    const currentCart = cart || await fetchCart();
    const snapshot = personalizedGroupSnapshot(currentCart, groupId);
    const updates = {};

    snapshot.services.forEach((service) => {
      const targetQty = personalizationServiceTargetQuantity(service, snapshot);
      const currentQty = Math.max(0, Number(service.quantity || 0));
      if (currentQty !== targetQty) updates[service.key] = targetQty;
    });

    if (!Object.keys(updates).length) return { changed: false, cart: currentCart };
    const updatedCart = await updateLines(updates);
    return { changed: true, cart: updatedCart };
  }

  async function repairAllPersonalizedGroups(options) {
    const opts = options || {};
    if (cartMutationBusy) return false;

    const cart = await fetchCart();
    const updates = {};
    personalizedGroupIds(cart).forEach((groupId) => {
      const snapshot = personalizedGroupSnapshot(cart, groupId);
      snapshot.services.forEach((service) => {
        const targetQty = personalizationServiceTargetQuantity(service, snapshot);
        const currentQty = Math.max(0, Number(service.quantity || 0));
        if (currentQty !== targetQty) updates[service.key] = targetQty;
      });
    });

    if (!Object.keys(updates).length) {
      try { sessionStorage.removeItem(CART_SYNC_RELOAD_KEY); } catch (e) {}
      return false;
    }

    cartMutationBusy = true;
    try {
      await updateLines(updates);
      if (opts.reload !== false) {
        let alreadyReloaded = false;
        try {
          alreadyReloaded = sessionStorage.getItem(CART_SYNC_RELOAD_KEY) === "1";
          sessionStorage.setItem(CART_SYNC_RELOAD_KEY, "1");
        } catch (e) {}
        if (!alreadyReloaded) window.location.reload();
      }
      return true;
    } finally {
      cartMutationBusy = false;
    }
  }

  // ---------------------------
  // Modal UI (creado por JS)
  // ---------------------------
  function ensureModal() {
    let modal = document.getElementById("dtfBundleModal");
    if (modal) return modal;

    modal = document.createElement("div");
    modal.id = "dtfBundleModal";
    modal.innerHTML = `
      <div class="dtf-bm-backdrop" data-bm-close></div>
      <div class="dtf-bm-panel" role="dialog" aria-modal="true" aria-labelledby="dtf-bm-title">
        <div class="dtf-bm-header">
          <h2 id="dtf-bm-title" class="dtf-bm-title">Actualizar detalle de pedido</h2>
          <button type="button" class="dtf-bm-close" data-bm-close aria-label="Cerrar">×</button>
        </div>

        <div class="dtf-bm-body">
          <table class="dtf-bm-table">
            <thead>
              <tr>
                <th>Producto</th>
                <th style="width: 160px;">Cantidad</th>
                <th style="width: 60px;"></th>
              </tr>
            </thead>
            <tbody id="dtf-bm-tbody"></tbody>
          </table>

          <p class="dtf-bm-note">
            Al guardar, las personalizaciones se ajustarán automáticamente al total de unidades.
          </p>

          <div class="dtf-bm-error" id="dtf-bm-error" style="display:none;"></div>
        </div>

        <div class="dtf-bm-footer">
          <button type="button" class="dtf-bm-save" id="dtf-bm-save">Guardar</button>
        </div>
      </div>
    `;

    const style = document.createElement("style");
    style.textContent = `
      #dtfBundleModal{position:fixed;inset:0;z-index:9999;display:none}
      #dtfBundleModal.is-open{display:block}
      #dtfBundleModal .dtf-bm-backdrop{position:absolute;inset:0;background:rgba(0,0,0,.35)}
      #dtfBundleModal .dtf-bm-panel{position:relative;background:#fff;width:min(760px,92vw);margin:6vh auto 0;border-radius:12px;overflow:hidden;box-shadow:0 18px 60px rgba(0,0,0,.25);max-height:88vh;display:flex;flex-direction:column}
      #dtfBundleModal .dtf-bm-header{display:flex;justify-content:space-between;align-items:center;padding:16px;border-bottom:1px solid rgba(0,0,0,.08)}
      #dtfBundleModal .dtf-bm-title{margin:0;font-size:18px;font-weight:750}
      #dtfBundleModal .dtf-bm-close{border:0;background:transparent;font-size:26px;cursor:pointer;line-height:1}
      #dtfBundleModal .dtf-bm-body{padding:16px;overflow:auto;flex:1 1 auto}
      #dtfBundleModal .dtf-bm-footer{padding:16px;border-top:1px solid rgba(0,0,0,.08);display:flex;justify-content:flex-end;flex:0 0 auto;background:#fff}
      #dtfBundleModal .dtf-bm-save{border:0;border-radius:8px;padding:10px 16px;background:#111;color:#fff;font-weight:650;cursor:pointer}
      #dtfBundleModal .dtf-bm-save:disabled{opacity:.65;cursor:progress}
      #dtfBundleModal .dtf-bm-table{width:100%;border-collapse:collapse}
      #dtfBundleModal .dtf-bm-table th,#dtfBundleModal .dtf-bm-table td{padding:10px;border-bottom:1px solid rgba(0,0,0,.08);text-align:left;vertical-align:middle}
      #dtfBundleModal .dtf-bm-note{margin:10px 0 0;font-size:13px;opacity:.75}
      #dtfBundleModal .dtf-bm-error{margin-top:10px;padding:10px 12px;border-radius:10px;background:#fdeaea;border:1px solid #f3b4b4;color:#b42318;font-weight:650}
      #dtfBundleModal input[type="number"]{width:120px;max-width:100%;padding:8px;border-radius:8px;border:1px solid rgba(0,0,0,.18)}
      #dtfBundleModal .dtf-bm-remove{border:1px solid rgba(0,0,0,.18);background:#fff;border-radius:8px;padding:8px 10px;cursor:pointer}
      #dtfBundleModal tr.is-removed{opacity:.55}
    `;
    document.head.appendChild(style);
    document.body.appendChild(modal);

    modal.addEventListener("click", (e) => {
      if (e.target && e.target.closest("[data-bm-close]")) closeModal();
    });

    document.addEventListener("keydown", (e) => {
      const isOpen = modal.classList.contains("is-open");
      if (!isOpen) return;
      if (e.key === "Escape") closeModal();
    });

    return modal;
  }

  function openModal() {
    ensureModal().classList.add("is-open");
  }

  function closeModal() {
    ensureModal().classList.remove("is-open");
  }

  function setModalError(msg) {
    const el = document.getElementById("dtf-bm-error");
    if (!el) return;
    if (!msg) {
      el.style.display = "none";
      el.textContent = "";
      return;
    }
    el.style.display = "block";
    el.textContent = msg;
  }

  // ---------------------------
  // Core: build + save
  // ---------------------------
  let currentCustomizationKeys = []; // [key,key...]
  let currentGroupId = null;

  function labelForItem(item) {
    const sku = item.sku ? String(item.sku) : "";
    const vtitle = item.variant_title ? String(item.variant_title) : "";
    const title = item.product_title ? String(item.product_title) : "";
    const parts = [];
    if (sku) parts.push(sku);
    if (vtitle && vtitle !== "Default Title") parts.push(vtitle);
    if (!parts.length) parts.push(title || "Producto");
    return parts.join(" — ");
  }

  async function loadGroup(groupId) {
    const cart = await fetchCart();

    const hoodies = [];
    const customKeys = [];

    (cart.items || []).forEach((it) => {
      if (!belongsToBundle(it, groupId)) return;

      // ✅ Guard: ignorar DTF (defensivo)
      if (isDTFLineBySignals(it)) return;

      const type = getProperty(it, "_item_type");
      if (type === "personalization") {
        customKeys.push(it.key);
      } else {
        hoodies.push({
          key: it.key,
          qty: it.quantity,
          label: labelForItem(it),
          color: itemOption(it, 0),
          size: itemOption(it, 1),
        });
      }
    });

    hoodies.sort(compareGarmentLines);
    return { hoodies, customKeys };
  }

  function renderModalRows(hoodies) {
    const tbody = document.getElementById("dtf-bm-tbody");
    if (!tbody) return;

    tbody.innerHTML = "";

    hoodies.forEach((h) => {
      const tr = document.createElement("tr");
      const qty = Number(h.qty) || 0;
      if (qty === 0) tr.classList.add("is-removed");
      tr.innerHTML = `
        <td>${escapeHtml(h.label)}</td>
        <td>
          <input class="dtf-bm-qty" type="number" min="0" step="1"
            data-line-key="${escapeHtml(h.key)}"
            value="${qty}">
        </td>
        <td class="dtf-bm-col-remove">
          <button type="button" class="dtf-bm-remove" data-line-key="${escapeHtml(
            h.key
          )}" aria-label="Eliminar variante">X</button>
        </td>
      `;
      tbody.appendChild(tr);
    });

    // v1.0-pre7: edición cómoda también dentro del carrito.
    // Un 0 se vacía al entrar; al salir, un campo vacío vuelve a 0.
    tbody.querySelectorAll(".dtf-bm-qty").forEach((input) => {
      input.addEventListener("focus", () => {
        if (String(input.value || "").trim() === "0") input.value = "";
        window.requestAnimationFrame(() => {
          try { input.select(); } catch (error) {}
        });
      });

      input.addEventListener("blur", () => {
        const value = Math.max(0, parseInt(input.value || "0", 10) || 0);
        input.value = String(value);
        const row = input.closest("tr");
        if (row) row.classList.toggle("is-removed", value === 0);
      });

      input.addEventListener("keydown", (event) => {
        if (event.key !== "Enter") return;
        event.preventDefault();
        input.blur();
      });
    });
  }

  async function saveChanges() {
    const saveBtn = document.getElementById("dtf-bm-save");
    if (!saveBtn || cartMutationBusy) return;

    setModalError(null);
    saveBtn.disabled = true;
    cartMutationBusy = true;

    try {
      const tbody = document.getElementById("dtf-bm-tbody");
      if (!tbody) throw new Error("No se encuentra el contenido del modal.");

      const inputs = Array.from(tbody.querySelectorAll("input[data-line-key]"));
      if (!inputs.length) throw new Error("No hay líneas para actualizar.");

      // Las prendas se cambian con change.js para que Shopify valide cada línea.
      // Después releemos el carrito y sincronizamos los servicios con el total REAL.
      for (const input of inputs) {
        const key = input.getAttribute("data-line-key");
        const qty = Math.max(0, parseInt(input.value || "0", 10) || 0);
        await changeLine(key, qty);
      }

      if (currentGroupId && !isNormalGroupId(currentGroupId)) {
        const cartAfterGarments = await fetchCart();
        await syncPersonalizationServices(currentGroupId, cartAfterGarments);
      }

      closeModal();
      window.location.reload();
    } catch (err) {
      // Incluso si falla una variante, dejamos los servicios alineados con las
      // prendas que Shopify haya aceptado realmente hasta ese momento.
      if (currentGroupId && !isNormalGroupId(currentGroupId)) {
        try {
          const currentCart = await fetchCart();
          await syncPersonalizationServices(currentGroupId, currentCart);
        } catch (syncError) {
          console.error("[23DTF] No se pudo reparar la personalización", syncError);
        }
      }
      setModalError(err && err.message ? err.message : "Error al guardar.");
    } finally {
      cartMutationBusy = false;
      saveBtn.disabled = false;
    }
  }

  // ---------------------------
  // Acordeón: desktop abierto / móvil cerrado
  // ---------------------------
  function setDefaultAccState() {
    const isDesktop = window.matchMedia("(min-width: 750px)").matches;
    document.querySelectorAll(".js-bundle-acc").forEach((d) => {
      const startClosed = d.getAttribute("data-start-closed") === "true";
      d.open = startClosed ? false : isDesktop; // desktop abierto salvo bloques marcados como cerrados
    });
  }

  setDefaultAccState();
  window.addEventListener("resize", function () {
    clearTimeout(window.__dtfAccT);
    window.__dtfAccT = setTimeout(setDefaultAccState, 180);
  });

  // ---------------------------
  // Bindings
  // ---------------------------

  // Abrir modal editar bundle
  document.addEventListener("click", async (e) => {
    const btn = e.target.closest("[data-edit-group]");
    if (!btn) return;

    const gid = getGroupIdFromRow(btn) || btn.getAttribute("data-edit-group");
    if (!gid) return;

    try {
      setModalError(null);
      openModal();

      const { hoodies, customKeys } = await loadGroup(gid);
      currentGroupId = gid;
      currentCustomizationKeys = customKeys;

      renderModalRows(hoodies);
    } catch (err) {
      closeModal();
      alert(err && err.message ? err.message : "No se pudo abrir el editor.");
    }
  });

  // Guardar modal
  document.addEventListener("click", (e) => {
    if (e.target && e.target.id === "dtf-bm-save") {
      saveChanges();
    }
  });

  // Eliminar una variante desde el modal (pone cantidad en 0)
  document.addEventListener("click", (e) => {
    const rm = e.target && e.target.closest ? e.target.closest(".dtf-bm-remove") : null;
    if (!rm) return;

    const key = rm.getAttribute("data-line-key");
    if (!key) return;

    const tbody = document.getElementById("dtf-bm-tbody");
    if (!tbody) return;

    const esc = window.CSS && CSS.escape ? CSS.escape(key) : key.replace(/[^a-zA-Z0-9_\-]/g, "\\$&");
    const input = tbody.querySelector('input[data-line-key="' + esc + '"]');
    if (input) {
      input.value = "0";
      input.dispatchEvent(new Event("input", { bubbles: true }));
      input.dispatchEvent(new Event("change", { bubbles: true }));
    }

    const row = rm.closest("tr");
    if (row) row.classList.add("is-removed");
  });

  // UX: si el usuario vuelve a poner qty > 0, quitamos el estado "removed"
  document.addEventListener("input", (e) => {
    const input = e.target;
    if (!input || !input.matches || !input.matches("#dtfBundleModal input[data-line-key]")) return;
    const row = input.closest("tr");
    if (!row) return;
    const val = Math.max(0, parseInt(input.value || "0", 10) || 0);
    row.classList.toggle("is-removed", val === 0);
  });

  // Eliminar bundle completo (prenda + personalizaciones) por _group_id
  document.addEventListener("click", async (e) => {
    const btn = e.target.closest("[data-delete-group]");
    if (!btn) return;

    const gid = btn.getAttribute("data-delete-group") || getGroupIdFromRow(btn);
    if (!gid) return;

    e.preventDefault();

    const ok = window.confirm("¿Eliminar este producto (y sus personalizaciones) del carrito?");
    if (!ok) return;

    if (cartMutationBusy) return;
    btn.disabled = true;
    btn.classList.add("is-loading");
    cartMutationBusy = true;

    try {
      let cart = await fetchCart();

      let groupItems = (cart && cart.items ? cart.items : []).filter((it) => {
        if (!belongsToBundle(it, gid)) return false;
        return !isDTFLineBySignals(it);
      });

      if (!groupItems.length) {
        window.location.reload();
        return;
      }

      const childUpdates = {};
      groupItems.filter(isPersonalizationService).forEach((item) => { childUpdates[item.key] = 0; });
      if (Object.keys(childUpdates).length) {
        await updateLines(childUpdates);
        cart = await fetchCart();
      }

      groupItems = (cart && cart.items ? cart.items : []).filter((it) => {
        if (!belongsToBundle(it, gid)) return false;
        return !isDTFLineBySignals(it);
      });
      const parentUpdates = {};
      groupItems.forEach((item) => { parentUpdates[item.key] = 0; });
      if (Object.keys(parentUpdates).length) await updateLines(parentUpdates);
      window.location.reload();
    } catch (err) {
      alert(err && err.message ? err.message : "No se pudo eliminar el bundle.");
      btn.disabled = false;
      btn.classList.remove("is-loading");
    } finally {
      cartMutationBusy = false;
    }
  });

  // v1.0-pre13A: al entrar en el carrito reparamos cada servicio según su prenda padre;
  // los grupos antiguos siguen usando el total del grupo como compatibilidad.
  // Esto cubre recargas, ediciones interrumpidas y restos de pruebas anteriores.
  const runInitialIntegrityRepair = () => {
    repairAllPersonalizedGroups({ reload: true }).catch((error) => {
      console.error("[23DTF] Comprobación de integridad del carrito", error);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runInitialIntegrityRepair, { once: true });
  } else {
    window.setTimeout(runInitialIntegrityRepair, 0);
  }
})();
